<li>
  <div class="title-container">
    <img [src]="iconSrc" alt="2ª via do Carnê">
    <h3>{{title}}</h3>
  </div>
  <div class="item-description">
    <p>
      {{description}}
    </p>
  </div>
</li>